/**
 * usePraticaStatus — F-005 Phase 4 (IMPL-P4-003).
 *
 * TanStack Query hook for a single pratica's status + timeline. Polls every 30s
 * while the pratica can still transition, and STOPS polling once the pratica
 * reaches a terminal state (`STATI_TERMINALI` from `@app/shared`, i.e.
 * `COMPLETATA` / `ANNULLATA`). Disabled until a `praticaId` is available.
 */
import { useQuery } from '@tanstack/react-query';
import { STATI_TERMINALI } from '@app/shared';

import { praticaStatusClient } from '../lib/pratica-status-client';

export function usePraticaStatus(praticaId: string | undefined) {
  return useQuery({
    queryKey: ['pratiche', 'status', praticaId],
    queryFn: () => praticaStatusClient.getStatus(praticaId!),
    enabled: !!praticaId,
    staleTime: 30_000,
    refetchInterval: (query) => {
      const stato = query.state.data?.stato;
      if (stato && STATI_TERMINALI.includes(stato)) return false;
      return 30_000;
    },
    refetchIntervalInBackground: false,
  });
}
